import React, { Component, createRef } from 'react'
import {
  Button,
  Input,
  message,
  Form,
  Image,
  Row,
  Col,
  Typography,
  Modal
} from 'antd'
import {
  UserOutlined,
  LockOutlined,
  SecurityScanOutlined
} from '@ant-design/icons'
import ProForm, { ModalForm, ProFormText } from '@ant-design/pro-form'
import { grey } from '@ant-design/colors'
import { connect } from '@utils/injectStore'
import { getAuth } from '@model/auth'
import { login } from '@redux/actions/basic/user'
import Password from '@components/Password'
import { fallback } from '@enum/image'
import { captchaImageSource } from './captchaImageSource'
import md5 from 'md5'
import { loginWithPwd } from '../api'

const FormItem = Form.Item
const iconStyle = {
  color: grey.primary
}

class LoginForm extends Component {
  password = createRef()
  state = {
    captcha: '',
    mfa: {}
  }

  componentDidMount() {
    this.getCaptcha()
  }

  getCaptcha = async () => {
    const params = {
      clientIp: '1.1.1.1'
    }
    let res = await getAuth(params, 1)
    if (res.code === 200 && res.data) {
      this.setState({
        captcha: '',
        captchaImage: res.data.captchaImage,
        captchaToken: res.data.captchaToken
      })
    }
  }

  handleSubmit = values => {
    const { captcha, captchaToken } = this.state
    if (captcha === '' || !captchaToken) {
      message.warning('请输入图形验证码！')
      return false
    }
    values.loginPwd = md5(values.loginPwd)
    values.captcha = captcha
    values.captchaToken = captchaToken
    values.loginType = 0
    this.loginWithPwd(values)
  }

  loginWithPwd = async formVal => {
    this.props.setLoading(true)

    try {
      const { data } = await loginWithPwd(formVal)
      if (!data.needMfaVerify) {
        this.loginWith2FA(data)
        return
      }

      this.setState({
        mfa: data
      })
    } catch (error) {
      message.error(error.message)
      this.getCaptcha()
    } finally {
      this.props.setLoading(false)
    }
  }

  loginWith2FA = async values => {
    const { login } = this.props
    const params = {
      loginCheckToken: this.state.mfa.loginCheckToken,
      ...values
    }

    await login(params)
  }

  cancelWith2FA = () => {
    this.setState({
      mfa: {}
    })
  }

  inputChange = (key, e) => {
    this.setState({
      [key]: e.target.value
    })
  }

  render() {
    const { captchaImage, captcha } = this.state
    return (
      <div>
        <Typography.Title level={2}>埃森哲云原生数字运营平台</Typography.Title>
        <Typography.Paragraph type="secondary">
          Welcome 欢迎登录
        </Typography.Paragraph>
        <Form onFinish={this.handleSubmit} className="login-form">
          <div>
            <FormItem
              name="loginName"
              rules={[{ required: true, message: '请输入用户名!' }]}
            >
              <Input
                size="large"
                prefix={<UserOutlined style={iconStyle} />}
                placeholder="用户名"
                name="name"
              />
            </FormItem>
            <FormItem
              name="loginPwd"
              rules={[{ required: true, message: '请输入登录密码！' }]}
            >
              <Password
                ref={this.password}
                size="large"
                placeholder="密码"
                prefix={<LockOutlined style={iconStyle} />}
              />
            </FormItem>
            <FormItem>
              <Row>
                <Col flex="auto">
                  <Input
                    size="large"
                    prefix={<SecurityScanOutlined style={iconStyle} />}
                    onChange={this.inputChange.bind(this, 'captcha')}
                    placeholder="图形验证码"
                    autoComplete="off"
                    value={captcha}
                  />
                </Col>
                <Col flex="111.11px">
                  <Image
                    height={40}
                    preview={false}
                    src={captchaImageSource(captchaImage)}
                    fallback={fallback}
                    onClick={this.getCaptcha}
                  />
                </Col>
              </Row>
            </FormItem>
            <FormItem>
              <Button block size="large" type="primary" htmlType="submit">
                登录
              </Button>
            </FormItem>
          </div>
        </Form>
        <ModalForm
          title="绑定两步验证"
          width={380}
          visible={this.state.mfa.mfaQrCode}
          onFinish={this.loginWith2FA}
          modalProps={{ onCancel: this.cancelWith2FA, destroyOnClose: true }}
        >
          <ProForm.Item label="绑定验证器">
            <Image src={this.state.mfa.mfaQrCode} />
          </ProForm.Item>
          <ProFormText
            label="校验动态密码"
            width="sm"
            name="mfaCode"
            required
            rules={[{ required: true }]}
          />
        </ModalForm>
        <ModalForm
          title="绑定两步验证"
          width={380}
          visible={!this.state.mfa.mfaQrCode && this.state.mfa.needMfaVerify}
          onFinish={this.loginWith2FA}
          modalProps={{ onCancel: this.cancelWith2FA, destroyOnClose: true }}
        >
          <ProFormText
            label="动态密码"
            width="sm"
            name="mfaCode"
            required
            rules={[{ required: true }]}
          />
        </ModalForm>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    userId: state.user.users.id
  }
}

export default connect(mapStateToProps, {
  login
})(LoginForm)
